<template>
  <div class="ap-buyer-index">
    <div class="clearfix acc-info" style="overflow: hidden;">
      <div class="float-left account" style="height:72px;">
        <img src="@/assets/icons/user.png" style="float:left;" />
        <div style="float:left;margin-left:10px;">
          <div>
            <strong>{{userDetail.name}}</strong>
          </div>
          <div>
            <strong>{{userDetail.userPrincipals[0].principal}}</strong>
          </div>
        </div>
      </div>
      <div class="float-left corp">
        <strong>{{userDetail.orgName}}</strong>
        <div class="font12">暂无信用等级</div>
      </div>
    </div>
    <div class="item">
      <div class="title">系统通知</div>
      <div class="result">
        <div class="left">
          <img src="@assets/icons/sad.png" />
        </div>
        <div class="right">
          <div class="title">资料审核未通过</div>
          <div class="desc">营业执照图片不符合要求，请修改后重新上传。</div>
          <!-- <div class="desc">2019-05-01 17:16</div> -->
        </div>
      </div>
      <div class="title" style="margin-top:20px;">重新提交认证资料</div>
      <hr />
      <div class="regist-form form2" style="width:500px;margin:0 auto;">
        <div class="form-group">
          <div class="input-group input-group-alt">
            <label class="input-group-prepend">
              <span class="input-group-text">
                <span style="color:#f00">*&nbsp;</span>公司名称
              </span>
            </label>
            <input type="text" v-model="companyName" class="form-control" @blur="blurCompanyName" />
          </div>
          <strong v-show="isChecked" class="checked">&nbsp;&nbsp;该公司名称已被占用。</strong>
        </div>
        <div class="clearfix">
          <div class="form-group">
            <div class="input-group input-group-alt">
              <label class="input-group-prepend">
                <span class="input-group-text">
                  <span style="color:#f00">*&nbsp;</span>联 系 人
                </span>
              </label>
              <input type="text" v-model="person" class="form-control" placeholder="姓名（用于业务联系）" />
            </div>
          </div>
        </div>
        <div class="clearfix form-group">
          <div class="float-left" style="width:33.3333%;padding-right:5px">
            <select v-model="currentProvince" @change="changeProvince" class="form-control">
              <option value disabled selected hidden>省</option>
              <option v-for="item in province" :key="item.id" :value="item.id">{{item.name}}</option>
            </select>
          </div>
          <div class="float-left" style="width:33.3333%;padding-left:5px">
            <select v-model="currentCity" @change="changeCity" class="form-control">
              <option value disabled selected hidden>市</option>
              <option v-for="item in city" :key="item.id" :value="item.id">{{item.name}}</option>
            </select>
          </div>
          <div class="float-left" style="width:33.3333%;padding-left: 10px">
            <select v-model="currentCounty" class="form-control">
              <option value disabled selected hidden>县</option>
              <option v-for="item in county" :key="item.id" :value="item.id">{{item.name}}</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <div class="input-group input-group-alt">
            <label class="input-group-prepend">
              <span class="input-group-text">
                <span style="color:#f00">*&nbsp;</span>详细地址
              </span>
            </label>
            <input type="text" v-model="address" class="form-control" />
          </div>
        </div>
        <div class="form-group">
          <div class="input-group input-group-alt">
            <label class="input-group-prepend">
              <span class="input-group-text">
                <span style="color:#f00">*&nbsp;</span>营业执照
              </span>
            </label>
            <div class="custom-file">
              <input type="file" accept=".jpg, .png" @change="changeFile" class="custom-file-input is-invalid" id="tfInvalid" ref="file" />
              <label class="custom-file-label" for="tfInvalid"></label>
            </div>
          </div>
        </div>
        <div class="clearfix">
          <div class="img-wrapper" @click="viewImg">
            <img style="width:100%;" :src="imgObjUrl" />
          </div>
          <div class="img-tips">
            <div class="title">图片资料要求</div>
            <div>
              拍摄并上传营业执照副本原件（复印件需加盖公章）
              请确保文件边角完整入镜，图中文字清晰可辨
              文件为jpg或png格式, 大小不超过8M
            </div>
          </div>
        </div>
        <hr />
        <div style="margin-top:30px" class="text-center">
          <button class="ap-btn-red ap-btn-red-hover1 ap-btn-middle" @click="finish">提交认证</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userDetail: {},
      imgObjUrl: "",
      isChecked: false, // 公司名是否被占用
      companyName: "", // 公司名称
      person: "", // 联系人
      province: "", // 省列表
      currentProvince: "", // 选中的省
      city: "", // 市列表
      currentCity: "", // 选中的市
      county: "", // 县列表
      currentCounty: "", // 选中的县
      address: "" // 详细地址
    };
  },
  created() {
    this.getUserDetail();
    this.getProvince();
  },
  methods: {
    getUserDetail() {
      this.$get("/spms/myProfiles/getProfile", {}, { noFailureMsg: true })
        .then(res => (this.userDetail = res))
        .catch(err => {});
    },
    getProvince() {
      this.$post("/dmhs/locations/query")
        .then(res => (this.province = res))
        .catch(err => {});
    },
    blurCompanyName() {
      this.$list(
        "/spms/registers/checkOrgName",
        {
          name: this.companyName
        },
        {
          success(res) {
            if (res) return (this.isChecked = true);
            this.isChecked = false;
          }
        }
      );
    },
    finish() {
      if (this.isChecked) return;
      if (!this.companyName) return $msg.warning("请输入公司名称！", 1);
      if (!this.person) return $msg.warning("请输入联系人！", 1);
      if (!this.currentCounty) return $msg.warning("请选择地区！", 1);
      if (!this.address) return $msg.warning("请输入详细地址！", 1);
      if (!this.$refs.file.files.length) return $msg.warning("请选择营业执照！", 1);
      this.$postFile(
        "/spms/auditTasks/create",
        {
          locationId: this.currentCounty,
          orgName: this.companyName,
          addrDetail: this.address,
          linkman: this.person,
          businessLicense: this.$refs.file.files[0]
        },
        function() {
          location.reload();
        }
      );
    },
    changeProvince() {
      this.city = [];
      this.county = [];
      this.currentCity = "";
      this.currentCounty = "";
      let idx = this.currentProvince.indexOf("_");
      this.$post(
        "/dmhs/locations/query",
        {
          parentId: idx != -1 ? this.currentProvince.substring(0, idx) : this.currentProvince
        },
        {
          success(data) {
            this.city = data;
          }
        }
      );
    },
    changeCity() {
      this.county = [];
      this.currentCounty = "";
      let idx = this.currentCity.indexOf("_");
      this.$post(
        "/dmhs/locations/query",
        {
          parentId: idx != -1 ? this.currentCity.substring(0, idx) : this.currentCity
        },
        {
          success(data) {
            this.county = data;
          }
        }
      );
    },
    changeFile() {
      var file = document.getElementById("tfInvalid");
      this.imgObjUrl = URL.createObjectURL(file.files[0]);
    },
    viewImg() {
      if (!this.imgObjUrl) return;
      const link = document.createElement("a");
      link.href = this.imgObjUrl;
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>

<style lang="less" scoped>
.form-group {
  position: relative;
  .checked {
    color: #f03;
    position: absolute;
    right: -160px;
    top: 0;
  }
}
.img-wrapper {
  cursor: pointer;
  width: 55%;
  float: left;
  min-height: 200px;
  border: 1px solid #ccc;
}
.img-tips {
  width: 40%;
  float: right;
  line-height: 24px;
  font-size: 12px;
  .title {
    color: #333333;
    font-size: 14px;
    margin: 0;
  }
}
.result {
  display: flex;
  border: 1px solid rgba(204, 204, 204);
  .left {
    width: 120px;
    height: 120px;
    img {
      margin: 28px;
    }
  }
  .right {
    .title {
      margin: 20px 0 0 0;
      font-weight: 700;
      font-size: 16px;
      color: #f03;
    }
    .desc {
      margin: 10px 0;
      font-size: 12px;
      font-family: "微软雅黑";
      font-weight: 400;
      color: #666666;
    }
  }
}
</style>